'use strict';

var Limber = module.exports = require('./js/core');

require('./js/template')(Limber);
require('./js/loader')(Limber);
